/* Strokes gained baseline — data only, no logic.
   PGA Tour ShotLink averages 2004–2012 as published in Mark Broadie,
   "Every Shot Counts" (2014): expected strokes to hole out.
   A correction to the baseline is an edit to this file and nothing else.
   Read by assets/strokes-gained-engine.js (browser: window.WGSGBaseline,
   Node tests: require()). Plan: AIS-OS projects/strokes-gained-calculator/PLAN.md §4. */
(function (root, factory) {
  var data = factory();
  if (typeof module === 'object' && module.exports) module.exports = data;
  else root.WGSGBaseline = data;
})(typeof self !== 'undefined' ? self : this, function () {
  'use strict';
  return {
    source: 'PGA Tour ShotLink 2004-2012 (Broadie, Every Shot Counts)',
    // Off the green, by yards to the hole. Columns: tee, fairway, rough, sand, recovery.
    // null = no published value; the engine's gap rules apply (tee < 100 → fairway,
    // recovery < 100 → rough + 0.50).
    long: [
      [20,  null, 2.40, 2.59, 2.53, null],
      [40,  null, 2.60, 2.78, 2.82, null],
      [60,  null, 2.70, 2.91, 3.15, null],
      [80,  null, 2.75, 2.96, 3.24, null],
      [100, 2.92, 2.80, 3.02, 3.23, 3.80],
      [120, 2.99, 2.85, 3.08, 3.21, 3.78],
      [140, 2.97, 2.91, 3.15, 3.22, 3.80],
      [160, 2.99, 2.98, 3.23, 3.28, 3.81],
      [180, 3.05, 3.08, 3.31, 3.40, 3.82],
      [200, 3.12, 3.19, 3.42, 3.55, 3.87],
      [220, 3.17, 3.32, 3.53, 3.70, 3.92],
      [240, 3.25, 3.45, 3.64, 3.84, 3.97],
      [260, 3.45, 3.58, 3.74, 3.93, 4.03],
      [280, 3.65, 3.69, 3.83, 4.00, 4.10],
      [300, 3.71, 3.78, 3.90, 4.04, 4.20],
      [320, 3.79, 3.84, 3.95, 4.12, 4.31],
      [340, 3.86, 3.88, 4.02, 4.26, 4.44],
      [360, 3.92, 3.95, 4.11, 4.41, 4.56],
      [380, 3.96, 4.03, 4.21, 4.55, 4.66],
      [400, 3.99, 4.11, 4.30, 4.69, 4.75],
      [420, 4.02, 4.15, 4.34, 4.73, 4.79],
      [440, 4.08, 4.20, 4.39, 4.78, 4.84],
      [460, 4.17, 4.29, 4.48, 4.87, 4.93],
      [480, 4.28, 4.40, 4.59, 4.98, 5.04],
      [500, 4.41, 4.53, 4.72, 5.11, 5.17],
      [520, 4.54, 4.66, 4.85, 5.24, 5.30],
      [540, 4.65, 4.78, 4.97, 5.36, 5.42],
      [560, 4.74, 4.86, 5.05, 5.44, 5.50],
      [580, 4.79, 4.91, 5.10, 5.49, 5.55],
      [600, 4.82, 4.94, 5.13, 5.52, 5.58]
    ],
    // On the green, by feet to the hole: expected putts. Matches the table
    // published on /blogs/whysguyscorner/strokes-gained-putting.
    putt: [
      [1, 1.00], [2, 1.01], [3, 1.05], [4, 1.13], [5, 1.23], [6, 1.34],
      [7, 1.42], [8, 1.50], [10, 1.61], [15, 1.78], [20, 1.87], [25, 1.94],
      [30, 2.00], [40, 2.12], [50, 2.21], [60, 2.28], [90, 2.40], [100, 2.45]
    ]
  };
});
